import api from './api';

// HTML 문자열 내 외부 이미지 src를 서버에 업로드 후 로컬 경로로 교체
export async function reuploadExternalImages(html) {
  if (!/<img[^>]+src=["']https?:\/\//i.test(html)) return html;

  const dom = new DOMParser().parseFromString(html, 'text/html');
  const imgs = Array.from(dom.querySelectorAll('img[src]'));
  const external = imgs.filter(img => /^https?:\/\//.test(img.getAttribute('src') || ''));

  await Promise.all(external.map(async (img) => {
    try {
      const r = await api.post('/boards/upload-from-url', { url: img.getAttribute('src') });
      img.setAttribute('src', r.data.url);
    } catch {
      // 실패 시 원본 URL 유지
    }
  }));

  return dom.body.innerHTML;
}
